<template>
  <div style="height: 100%;">
    <v-progress-linear height="4" :indeterminate="true" v-if="isLoading" style="margin: -2px;"></v-progress-linear>
    <v-tooltip top v-if="loadFailed">
      <v-btn slot="activator" flat icon color="error" @click="update(alltime)">
        <v-icon>refresh</v-icon>
      </v-btn>
      Reload
    </v-tooltip>
    <bar v-if="!loadFailed" :style="barStyle" :chart-data="datacollection" :options="chartOptions"/>
    <v-layout row justify-center="true">
      <v-menu
      transition="slide-x-transition"
      bottom
      right
      >
        <v-tooltip top slot="activator">
        <v-btn
            icon
          slot="activator"
          flat color="grey"
        >
          <v-icon>insert_chart_outlined</v-icon>
        </v-btn>
          {{ origin }}
        </v-tooltip>


        <v-list>
          <v-list-tile
            v-for="(item, i) in origins"
            :key="i"
            @click="origin = item"
          >
            <v-list-tile-title>{{ item }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-dialog v-if="!loadFailed"
        v-model="dialog"
        width="810"
      >
        <v-btn style="" flat color="grey" slot="activator">
          <v-icon>date_range</v-icon>
          {{request_startdate}} - {{request_todate}}
        </v-btn>
        <date-range :callback-event="childUpdate"/>
      </v-dialog>

      <v-dialog v-model="dialog2" width="500">
        <v-btn slot="activator" color="red lighten-2" dark>{{ $vuetify.t('$vuetify.dashboard.tooltips.informations') }}</v-btn>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{ $vuetify.t('$vuetify.dashboard.tooltips.informations') }}</v-card-title>
          <v-card-text>
            <div> 
              {{ $vuetify.t('$vuetify.charts.totalValue') }} : {{totalValue}} <br>
            </div>
            <div> 
              {{ $vuetify.t('$vuetify.charts.globalAverage') }} : {{globalAverage}} <br>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="dialog2 = false">{{ $vuetify.t('$vuetify.dashboard.tooltips.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import Bar from '../Chartjs/BarChart'
import DateRange from '../Misc/DateRange'
const axios = require('axios')
const tradName = 'numberOfScenesVisited'
const phpName = 'NumberOfScenesVisited'
const serverDir = process.env.API_URL
const color = '#f87979'

export default {
  props: {
    barStyle: {
      type: String,
      required: false,
      default: 'height: calc(100% - 82px);'
    }
  },
  data: function () {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            ticks: {
              min: 0
            },
            scaleLabel: {
              display: true,
              labelString: this.$vuetify.t('$vuetify.charts.' + tradName + '.yaxis')
            }
          }],
          xAxes: [{
            ticks: {
              display: false
            },
            scaleLabel: {
              display: true,
              labelString: this.$vuetify.t('$vuetify.charts.' + tradName + '.xaxis')
            }
          }]
        },
        tooltips: {
          callbacks: {
            title: function (title) {
              return title[0].xLabel[0].toUpperCase() + title[0].xLabel.substring(1).split('_').join(' ')
            },
            label: function (tooltipItem) {
              return tooltipItem.yLabel
            }
          },
          type: 'index',
          axis: 'x',
          intersect: false
        }
      },
      isLoading: true,
      loadFailed: false,
      datacollection: {},
      dialog: false,
      dialog2: false,
      range: [],
      totalValue: '0',
      globalAverage: '0',
      request_startdate: '',
      request_todate: '',
      alltime: true,
      carousels: ['MERCUREROISSY', 'NOVOTELBERCY'],
      origin: this.$vuetify.t('$vuetify.charts.All'),
      origins: [this.$vuetify.t('$vuetify.charts.All'), this.$vuetify.t('$vuetify.charts.Direct'), this.$vuetify.t('$vuetify.charts.Carousels')]
    }
  },
  mounted () {
    this.update(true)
  },
  components: {
    'bar': Bar,
    'date-range': DateRange
  },
  watch: {
    'origin': 'update'
  },
  methods: {
    update (alltime = false) {
      var x = setInterval(() => {
        this.group = this.$root.$children[0].group
        if (this.group != ''){
          clearInterval(x)
          var carouselclient = ''
          if (this.carousels.includes(this.group)){
            carouselclient = this.group.toLowerCase()
            this.group = 'CAROUSEL'
          }
          this.isLoading = true
          this.loadFailed = false
          var labels = []
          var data = []
          var self = this
          var start = ''
          var end = ''
          var origin = this.origin
          if (origin == 'Tout'){
            origin = 'All'
          }
          if (this.range.length != 0){
            start = this.range[0]
            end = this.range[1]
          }
          else {
            start = new Date()
            start.setMonth(start.getMonth() - 1)
            start = this.getDateGoodFormat(start)
            end = new Date()
            end = this.getDateGoodFormat(end)
          }
          this.request_startdate = start
          this.request_todate = end
          var envID = ''
          if (this.group != 'DIAKSE'){
            envID = this.group
          }
          else{
            envID = 'AUCHAN'
          }
          var unknown = 'true'
          // Make a request for a user with a given ID
          // axios.get('http://adammeraihi.000webhostapp.com/charts/modeles/' + phpName + '.php', (!alltime ? 'start=' + start + '&end=' + end + '&' : ''))
          // axios.get('http://localhost/stats/PHP/' + phpName + '.php?' + (!alltime ? 'start=' + start + '&end=' + end + '&' : ''))
          axios.get(serverDir + phpName + '?' + '&start[]=' + start + '&end[]=' + end + '&envID[]=' + envID + '&unknown[]=' + unknown + '&origin[]=' + origin + '&carouselclient[]=' + carouselclient)
          .then(function (response) {
            // handle success
            labels = Object.keys(response.data.result)
            data = Object.values(response.data.result)
            self.globalAverage = response.data.average
            self.totalValue = response.data.nbrScenesVisited

            // Overwriting base render method with actual data.
            self.datacollection = {
              labels: labels,
              datasets: [
                {
                  label: self.$vuetify.t('$vuetify.charts.' + tradName + '.legend'),
                  backgroundColor: color,
                  data: data
                }
              ]
            }
          })
          .catch(function (error) {
            // handle error
            self.loadFailed = true
            console.log(error)
          })
          .then(function () {
            self.isLoading = false
          })
        }
      }, 200)
    },
    childUpdate (val) {
      if (typeof val === 'boolean') {
        this.alltime = val
        this.update(val)
      } else {
        this.range = val
        this.update(this.alltime)
      }
    },
    getDateGoodFormat(dateToChange){
      var month = ('0' + (dateToChange.getMonth() + 1)).slice(-2)
      var date = ('0' + dateToChange.getDate()).slice(-2)
      var year = dateToChange.getFullYear()
      return (year + '-' + month + '-' + date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Charts/NumberOfScenesVisited.vue